import { render, staticRenderFns } from "./CreateProFormaInvoice.vue?vue&type=template&id=395ccd34"
import script from "./CreateProFormaInvoice.vue?vue&type=script&lang=js"
export * from "./CreateProFormaInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports